<template>
  <div>
    <template v-if="modeIs('select')">
      <field-item
          v-for="variable in handler.getElements()"
          :key="variable.clientIdOrId"
          :disabled="handler.isDisabled(variable)"
          @click="select(handler.selectVariable(variable))"
          class="pt-2 pl-2">
        <row>
          <prefix>
            <icon :glyph="varIOClass(variable)"/>
          </prefix>
          <column>
            {{variable.name}}
          </column>
        </row>
      </field-item>
    </template>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import ProcessFlowVariablesHandler from "~/models/dynamicFields/handlers/processFlows/processFlowVariablesHandler";
  import handlerComponentsMixin from '../mixins/handlerComponentsMixin';
  import FieldItem from './common/field-item.vue';
  import DynamicElementMixin from './common/dynamic-element-mixin.vue';

  export default Vue.extend({
    mixins: [handlerComponentsMixin, DynamicElementMixin],
    components: {
      FieldItem,
    },
    props: {
      handler: {
        type: Object as () => ProcessFlowVariablesHandler,
        required: true,
      },
    },
  });
</script>